import $ from 'jquery'

const HSFORMS_SCRIPT = '//js.hsforms.net/forms/embed/v2.js'
let scrollPosition = 0
let hubspotScriptPromise = null

$(document).ready(function () {
  initVideoTeaser()
})

function initVideoTeaser() {
  // Move modals to <body> so parent stacking contexts cannot cover them.
  $('.video-teaser-modal').each(function () {
    document.body.appendChild(this)
  })

  $(document).on('click', '.js-video-teaser-play', function (e) {
    e.preventDefault()

    const $teaser = $(this).closest('.dhsv_vc_video_teaser')
    const videoId = $teaser.data('video-id')
    const embedUrl = $teaser.data('embed-url')
    const videoType = String($teaser.data('video-type') || '')
    const hasHubspot = String($teaser.data('has-hubspot')) === '1'
    const $modal = $(`#${videoId}`)

    if (!embedUrl || !$modal.length) {
      return
    }

    const hsFormId = String($teaser.data('hs-form-id') || '')
    const storageKey = hsFormId
      ? `videoTeaserFormSubmitted_${hsFormId}`
      : `videoTeaserFormSubmitted_${videoId}`

    openVideoTeaserModal($modal, {
      embedUrl,
      videoType,
      hasHubspot,
      hsRegion: String($teaser.data('hs-region') || ''),
      hsPortalId: String($teaser.data('hs-portal-id') || ''),
      hsFormId,
      storageKey,
    })
  })

  $(document).on('click', '.js-video-teaser-close', function (e) {
    e.preventDefault()
    e.stopPropagation()
    closeVideoTeaserModal($(this).closest('.video-teaser-modal'))
  })

  $(document).on('click', '.video-teaser-modal', function (e) {
    if (e.target === this) {
      closeVideoTeaserModal($(this))
    }
  })

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      const $openModal = $('.video-teaser-modal.show')
      if ($openModal.length) {
        closeVideoTeaserModal($openModal)
      }
    }
  })

  bindHubspotSubmissionListeners()
}

/**
 * HubSpot submit detection is unreliable across form builders / embed versions.
 * Cover all known signals used elsewhere in this project.
 */
function bindHubspotSubmissionListeners() {
  // Legacy iframe postMessage callback
  window.addEventListener('message', function (event) {
    const data = event.data
    if (
      !data ||
      data.type !== 'hsFormCallback' ||
      (data.eventName !== 'onFormSubmitted' && data.eventName !== 'onFormSubmit')
    ) {
      return
    }

    handleHubspotSubmission({
      formId: data.id || '',
      sourceWindow: event.source,
    })
  })

  // New HubSpot global form events (updated form editor)
  window.addEventListener('hs-form-event:on-submission:success', function (
    event
  ) {
    const detail = (event && event.detail) || {}
    handleHubspotSubmission({
      formId: detail.formId || '',
    })
  })
}

function handleHubspotSubmission({ formId = '', sourceWindow = null } = {}) {
  let $modal = findOpenVideoTeaserModalBySource(sourceWindow)

  if (!$modal.length) {
    $modal = $('.video-teaser-modal.show').filter(function () {
      const options = $(this).data('teaserOptions')
      return options && options.hasHubspot
    })
  }

  if (!$modal.length) {
    return
  }

  $modal.each(function () {
    const $current = $(this)
    const options = $current.data('teaserOptions')
    if (!options || !options.hasHubspot) {
      return
    }

    // Only filter by form id when both sides provide one.
    if (
      formId &&
      options.hsFormId &&
      String(formId).toLowerCase() !== String(options.hsFormId).toLowerCase()
    ) {
      return
    }

    unlockAndPlayVideoTeaser($current)
  })
}

function findOpenVideoTeaserModalBySource(sourceWindow) {
  if (!sourceWindow) {
    return $()
  }

  const $openModals = $('.video-teaser-modal.show')
  for (let i = 0; i < $openModals.length; i++) {
    const $modal = $openModals.eq(i)
    const $iframes = $modal.find('.js-video-teaser-hs-form iframe')
    for (let j = 0; j < $iframes.length; j++) {
      try {
        if ($iframes[j].contentWindow === sourceWindow) {
          return $modal
        }
      } catch (_) {
        // cross-origin: ignore
      }
    }
  }

  return $()
}

function lockPageScroll() {
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0
  $('html, body').addClass('video-teaser-modal-open')
  $('body').css('top', `-${scrollPosition}px`)
}

function unlockPageScroll() {
  $('html, body').removeClass('video-teaser-modal-open')
  $('body').css('top', '')
  window.scrollTo(0, scrollPosition)
}

function openVideoTeaserModal($modal, options) {
  if ($modal.parent()[0] !== document.body) {
    document.body.appendChild($modal[0])
  }

  $modal.data('teaserOptions', options)
  $modal.data('videoUnlocked', false)

  const alreadySubmitted =
    options.hasHubspot &&
    options.storageKey &&
    localStorage.getItem(options.storageKey)

  lockPageScroll()
  $modal.addClass('show')
  $modal.attr('aria-hidden', 'false')

  if (options.hasHubspot && !alreadySubmitted) {
    showFormStep($modal)
    loadHubspotForm($modal, options)
  } else {
    showPlayerStep($modal)
    startVideoPlayback($modal, options)
  }
}

function showFormStep($modal) {
  const $formStep = $modal.find('.js-video-teaser-form-step')
  const $playerStep = $modal.find('.js-video-teaser-player-step')

  $formStep.removeClass('is-hidden').removeAttr('hidden')
  $playerStep.addClass('is-hidden').attr('hidden', 'hidden')
  $modal.addClass('is-form-step').removeClass('is-player-step')
}

function showPlayerStep($modal) {
  const $formStep = $modal.find('.js-video-teaser-form-step')
  const $playerStep = $modal.find('.js-video-teaser-player-step')

  $formStep.addClass('is-hidden').attr('hidden', 'hidden')
  $playerStep.removeClass('is-hidden').removeAttr('hidden')
  $modal.addClass('is-player-step').removeClass('is-form-step')
}

function loadHubspotScript() {
  if (window.hbspt && window.hbspt.forms && window.hbspt.forms.create) {
    return Promise.resolve()
  }

  if (hubspotScriptPromise) {
    return hubspotScriptPromise
  }

  hubspotScriptPromise = new Promise(function (resolve, reject) {
    const finish = function () {
      if (window.hbspt && window.hbspt.forms && window.hbspt.forms.create) {
        resolve()
        return true
      }
      return false
    }

    if (finish()) {
      return
    }

    const existing = document.querySelector(`script[src="${HSFORMS_SCRIPT}"]`)
    if (existing) {
      const check = setInterval(function () {
        if (finish()) {
          clearInterval(check)
        }
      }, 50)
      setTimeout(function () {
        clearInterval(check)
        if (!finish()) {
          reject(new Error('HubSpot forms script timed out'))
        }
      }, 10000)
      existing.addEventListener('load', function () {
        if (finish()) {
          clearInterval(check)
        }
      })
      existing.addEventListener('error', function () {
        clearInterval(check)
        reject(new Error('HubSpot forms script failed to load'))
      })
      return
    }

    const script = document.createElement('script')
    script.charset = 'utf-8'
    script.src = HSFORMS_SCRIPT
    script.onload = function () {
      if (!finish()) {
        reject(new Error('HubSpot forms API unavailable after script load'))
      }
    }
    script.onerror = function () {
      reject(new Error('HubSpot forms script failed to load'))
    }
    document.head.appendChild(script)
  })

  return hubspotScriptPromise
}

function loadHubspotForm($modal, options) {
  const $target = $modal.find('.js-video-teaser-hs-form')
  if (!$target.length) {
    return
  }

  const targetSelector = `#${$target.attr('id')}`

  loadHubspotScript()
    .then(function () {
      bindFormSuccessObserver($modal)

      if ($target.data('hsFormLoaded')) {
        return
      }

      window.hbspt.forms.create({
        region: options.hsRegion,
        portalId: options.hsPortalId,
        formId: options.hsFormId,
        target: targetSelector,
        onFormSubmit: function () {
          // Fires after validation, before HubSpot acknowledges submission.
          // Keep as early fallback; unlock is idempotent.
        },
        onFormSubmitted: function () {
          unlockAndPlayVideoTeaser($modal)
        },
        onFormReady: function ($form) {
          // Legacy event used by other modules in this theme.
          if ($form && $form.length && $form[0]) {
            $form[0].addEventListener(
              'hsvalidatedsubmit',
              function () {
                unlockAndPlayVideoTeaser($modal)
              },
              { once: true }
            )
          }
        },
      })

      $target.data('hsFormLoaded', true)
    })
    .catch(function () {
      $target.html(
        '<p class="video-teaser-modal__form-error">Unable to load the form. Please try again later.</p>'
      )
    })
}

/**
 * Most reliable fallback when callbacks don't fire: HubSpot injects
 * `.submitted-message` into the form target after a successful submit.
 */
function bindFormSuccessObserver($modal) {
  const $formStep = $modal.find('.js-video-teaser-form-step')
  if (!$formStep.length || $formStep.data('observerAttached')) {
    return
  }

  const observer = new MutationObserver(function () {
    if (
      $formStep.find('.submitted-message, .hs-form-submitted').length ||
      $formStep.find('.hs-form.submitted-message').length
    ) {
      unlockAndPlayVideoTeaser($modal)
    }
  })

  observer.observe($formStep.get(0), { childList: true, subtree: true })
  $formStep.data('observerAttached', true)
  $formStep.data('observer', observer)
}

function unlockAndPlayVideoTeaser($modal) {
  if (!$modal || !$modal.length) {
    return
  }

  const options = $modal.data('teaserOptions')
  if (!options) {
    return
  }

  if ($modal.data('videoUnlocked')) {
    return
  }
  $modal.data('videoUnlocked', true)

  if (options.storageKey) {
    localStorage.setItem(options.storageKey, 'true')
  }

  // Brief pause so the HubSpot success state can register, then switch to video.
  window.setTimeout(function () {
    if (!$modal.hasClass('show')) {
      return
    }
    showPlayerStep($modal)
    startVideoPlayback($modal, options)
  }, 400)
}

function startVideoPlayback($modal, options) {
  const usesIframe =
    options.videoType === 'youtube' || options.videoType === 'streambuzzer'

  if (usesIframe) {
    const $iframe = $modal.find('.js-video-teaser-player-step iframe')
    if ($iframe.length) {
      $iframe.attr('src', options.embedUrl)
    }
    return
  }

  const $video = $modal.find('.js-video-teaser-player-step video')
  if (!$video.length || !$video[0]) {
    return
  }

  $video.find('source').attr('src', options.embedUrl)
  $video[0].load()
  $video[0].play().catch(function () {
    // Autoplay may be blocked; controls remain available.
  })
}

function closeVideoTeaserModal($modal) {
  const $iframe = $modal.find('.js-video-teaser-player-step iframe')
  if ($iframe.length) {
    $iframe.attr('src', '')
  }

  const $video = $modal.find('.js-video-teaser-player-step video')
  if ($video.length && $video[0]) {
    $video[0].pause()
    $video.find('source').attr('src', '')
    $video[0].load()
  }

  const options = $modal.data('teaserOptions')
  const alreadySubmitted =
    options &&
    options.hasHubspot &&
    options.storageKey &&
    localStorage.getItem(options.storageKey)

  if (options && options.hasHubspot && !alreadySubmitted) {
    showFormStep($modal)
  }

  $modal.data('videoUnlocked', false)
  $modal.removeClass('show is-form-step is-player-step')
  $modal.attr('aria-hidden', 'true')

  if (!$('.video-teaser-modal.show').length) {
    unlockPageScroll()
  }
}
